let socialIcon = document.querySelectorAll('.modal-request .social-area a');

function activeIcon(e) {
	let actives = document.getElementsByClassName('active-icon');

	let currentActive = actives[0];
	if (currentActive) {
		currentActive.classList.remove('active-icon');
	}

	if (currentActive !== e) {
		e.classList.add('active-icon');
	}
}

socialIcon.forEach(function (s) {
	s.addEventListener('click', (e) => {
		let socialForm = document.querySelectorAll('.choice-social .form-group');

		socialForm.forEach(item => {
			item.classList.remove('d-block');
		});

		let index = s.href.indexOf('#');
		let id = s.href.substring(index + 1);
		document.getElementById(id).classList.add('d-block');

		let inputsDisableRequired = document.querySelectorAll('.choice-social-item input[type=text]');
		for (let i = 0; i < inputsDisableRequired.length; i++) {
			inputsDisableRequired[i].required = false;
		}

		let inputsRequired = document.querySelectorAll('#' + id + ' input[type=text]');
		for (let i = 0; i < inputsRequired.length; i++) {
			inputsRequired[i].required = true;
		}

		activeIcon(s);

		e.preventDefault();

		return false;
	});
});